import React, { useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import CustomPressable from '../../../components/customPressable/customPressable';
import { formatDate } from '../../../js/formatDate';
import { CustomTextInput } from '../../../components/customTextInput';

const ReservationUpdate = (props) => {
    const { editReservation, setEditReservation, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice?.extraConfigParam) || false;
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const [guestComment, setGuestComment] = useState(editReservation?.client_requests);



    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsUpdateHeaderContainer'])} id='sevenRoomsUpdateHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsUpdateHeaderImg'])} id={"sevenRoomsUpdateHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsUpdateMainPageHeaderTitleContainer'])} id='sevenRoomsUpdateMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsUpdateHeaderTitle'])} id='sevenRoomsUpdateHeaderTitle'>{t(`reservations.heading_update_reservation`)}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsUpdateHeaderSubTitle'])} id='sevenRoomsUpdateHeaderSubTitle'>{editReservation?.name || ""}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsUpdateRootContainer'])} id="widgetRootContainer sevenRoomsUpdateRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsUpdateMainContainer'])} 
                showsVerticalScrollIndicator={false}
                nestedScrollEnabled
                id='sevenRoomsUpdateMainContainer'
            >
                {renderHeader()}
                                                
                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsUpdateMainContainerChildContainer'])} id='sevenRoomsUpdateMainContainerChildContainer'>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('reservations.preferred_date')}</Text>
                        <CustomTextInput
                            value={editReservation?.date ? formatDate(editReservation?.date, dateFormat) : ""}
                            editable={false}
                            pointerEvents="none"
                        />
                    </View>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('reservations.time_slot')}</Text>
                        <CustomTextInput
                            value={editReservation?.real_datetime_of_slot || ""}
                            editable={false}
                            pointerEvents="none"
                        />
                    </View>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('reservations.max_guest')}</Text>
                        <CustomTextInput
                            value={editReservation?.max_guests || ""}
                            editable={false}
                            pointerEvents="none"
                        />
                    </View>

                    <View style={getStyles(['textContainer'])} id='textContainer'>
                        <Text style={getStyles(['label'])} id='label'>{t('reservations.special_request')}</Text>
                        <CustomTextInput
                            style={{ height: 100 }}
                            value={guestComment}
                            onChangeText={(value) => setGuestComment(value)}
                            placeholder={t('reservations.special_request_placeholder')}
                            multiline
                            numberOfLines={3}
                        />
                    </View>


                </View>
                
            </ScrollView>
            <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable 
                    style={getStyles(['primaryBtn'])} 
                    onPress={() => handleNext({ reservationId: editReservation.id, guestComment: guestComment })} 
                    id='primaryBtn'
                >
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.update_reservation')}</Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack} id='secondaryBtn'>
                    <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('reservations.back')}</Text>
                </CustomPressable> */}
            </View>


        </View>
    )
}

export default ReservationUpdate
